export const workOrders = [
  {
    id: 1,
      vendorname:"Kumail Enterprises",
    projectName: "Mall Project",
    remainingAmount: 75000,
       workstatus: {
      inProgress: 1,
      completed: 4,
      remaining: 1,
    },
  },
    {
    id: 2,
   vendorname:"Rahul Traders",
    projectName: "Office Renovation",
    remainingAmount: 0,
       workstatus: {
      inProgress: 1,
      completed: 4,
      remaining: 1,
    },
  },
    {
    id: 3,
     vendorname:"Ak infra",
    projectName: "Apartment Complex",
    remainingAmount: 50000,
       workstatus: {
      inProgress: 1,
      completed: 4,
      remaining: 1,
    },
    }];